import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCategoriesComponent } from './product-categories.component';
import { ProductCategoriesItemComponent } from './components/product-categories-item/product-categories-item.component';
import { TranslocoModule } from '@ngneat/transloco';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    ProductCategoriesComponent,
    ProductCategoriesItemComponent
  ],
  exports: [
    ProductCategoriesComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    MatButtonModule,
  ],
})
export class ProductCategoriesModule { }
